import { render, staticRenderFns } from "./SpecialServicesModel.vue?vue&type=template&id=64c776eb&scoped=true&"
import script from "./SpecialServicesModel.vue?vue&type=script&lang=js&"
export * from "./SpecialServicesModel.vue?vue&type=script&lang=js&"
import style0 from "./SpecialServicesModel.vue?vue&type=style&index=0&id=64c776eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c776eb",
  null
  
)

export default component.exports